const initialState = { error: null, columns: [], columnsOrder: [], comments: [], items: [], profiles: [], selectedItem: false, userStory: [], userStoryOrder: [] };
export default function kanban(state = initialState) {
  return state;
}
